export default __webpack_public_path__ + "static/media/volume.0194cc50.webp";